<script lang="ts" setup>
import { Feedback } from '@/models/feedback.model';
import { Mutations, ShiftCMSState } from '@/store';
import { FeedbackActions, FeedbackState } from '@/stores/feedback.store';
import { UsersActions } from '@/stores/users.store';
import { markRaw, PropType, ref } from 'vue';
import { useStore } from 'vuex';
import UserInfo from '../users/UserInfo.vue';

const store = useStore<ShiftCMSState & { fs: FeedbackState }>();

const props = defineProps({
  data: {
    type: Object as PropType<Feedback>,
    required: true,
  },
});

const getSource = (m: Feedback) => {
  return m.file ? `/file/${m.file.uuid}/original.webp` : '';
};

const removeFeedback = async (d: Feedback) => {
  store.dispatch(FeedbackActions.DeleteFeedback, d.id);
  store.commit(Mutations.HideDrawer);
};

const resolveFeedback = async (d: Feedback) => {
  store.dispatch(FeedbackActions.ResolveFeedback, d.id);
  store.commit(Mutations.HideDrawer);
};

const internalReply = ref<string>(props.data.internalReply);

function saveReply() {
  store.dispatch(FeedbackActions.UpdateFeedback, {
    ...props.data,
    internalReply: internalReply.value,
  });
  store.commit(Mutations.HideDrawer);
}

async function seeUser(user: { name: string; userId: number }) {
  const u = await store.dispatch(UsersActions.GetUser, user.userId);

  store.commit(Mutations.ShowSubDrawer, {
    component: markRaw(UserInfo),
    data: u,
    small: true,
  });
}
</script>
<template>
  <v-container>
    <h2>
      Feedback from {{ data.user.name }}
      <v-btn type="button" color="info" class="mr-4" @click="seeUser(data.user)"
        >See user</v-btn
      >
      <v-btn type="button" color="warning" @click="removeFeedback(data)"
        >Delete</v-btn
      >
      <v-btn
        v-if="!data.resolved"
        type="button"
        class="ml-4"
        color="info"
        @click="resolveFeedback(data)"
        >Resolve</v-btn
      >
    </h2>
    <br />

    <v-row class="mb-8">
      <v-col>
        <p>{{ data.message }}</p>
      </v-col>
      <v-col>
        <v-form @submit.prevent="saveReply">
          <v-textarea
            v-model="internalReply"
            label="Internal reply"
            density="compact"
            required
          ></v-textarea>
          <v-btn type="submit" color="primary">Save</v-btn>
        </v-form>
      </v-col>
    </v-row>

    <center>
      <img :src="getSource(data)" width="50%" class="screenshot" />
    </center>
  </v-container>
</template>
<style scoped>
.screenshot {
  display: block;
  border-radius: 16px;
  box-shadow: 2px 2px 4px rgb(74, 74, 74);
}
</style>
